export default "__VITE_ASSET__Dvv3QFll__"